// Shared "What to sail" target speeds + PMF Performance metric.
// Read from PMF's polar (Sun Odyssey 45 PTE, MSC + 6 on the rail).
// One source of truth for: the Stats "What to sail" card, the PMF Performance
// Index, and the PMF Perf figure shown on each race recap header.
import { computeRaceSog } from "./raceSog";

export const TARGET_TWS = [6, 10, 14, 20];

export const TARGETS = [
  { a: "45",  v: [3.8, 5.8, 6.6, 7.0] },
  { a: "60",  v: [4.3, 6.4, 7.1, 7.6] },
  { a: "90",  v: [4.6, 6.8, 7.6, 8.1] },
  { a: "120", v: [4.3, 6.5, 7.4, 8.2] },
  { a: "150", v: [3.3, 5.3, 6.3, 7.3] },
  { a: "180", v: [2.7, 4.6, 5.6, 6.6] },
];

const T_ALL = TARGETS.flatMap((r) => r.v);
export const T_MIN = Math.min(...T_ALL);
export const T_MAX = Math.max(...T_ALL);

// All-around target = mean of the polar column for a given wind (proxy for a
// mixed buoy course that spends time upwind, reaching, and downwind).
const T_MEANS = TARGET_TWS.map((_, c) => TARGETS.reduce((s, r) => s + r.v[c], 0) / TARGETS.length);

export function interpTarget(w) {
  if (w <= TARGET_TWS[0]) return T_MEANS[0];
  if (w >= TARGET_TWS[TARGET_TWS.length - 1]) return T_MEANS[T_MEANS.length - 1];
  for (let i = 0; i < TARGET_TWS.length - 1; i++) {
    if (w >= TARGET_TWS[i] && w <= TARGET_TWS[i + 1]) {
      const t = (w - TARGET_TWS[i]) / (TARGET_TWS[i + 1] - TARGET_TWS[i]);
      return T_MEANS[i] + t * (T_MEANS[i + 1] - T_MEANS[i]);
    }
  }
  return T_MEANS[0];
}

export function nearestCol(w) {
  let bi = 0, bd = 1e9;
  TARGET_TWS.forEach((t, i) => { const d = Math.abs(t - w); if (d < bd) { bd = d; bi = i; } });
  return bi;
}

// PMF Perf %: average boat speed vs the boat's all-around polar target for the
// average wind that race. >100 means we beat the all-around target (often puffy
// days where gusts lift the average). Returns null when speed/wind aren't logged.
export function pmfPerf(race) {
  // Use RACE SOG (distance sailed / race time), not the overall logged avg SOG
  // — the latter includes pre-start, post-finish and any motoring. Races with
  // no GPX distance return null and simply don't count toward the average.
  const rs = parseFloat(computeRaceSog(race && race.distance, race && race.time)) || 0;
  const w = parseFloat(race && race.avgTws) || 0;
  if (!(rs > 0 && w > 0)) return null;
  return Math.round((rs / interpTarget(w)) * 100);
}
